export const _colorVars = {
    utkColorAdcDarkGreen: '#297708',
    utkColorAdcLightGreen: '#77bc1f',
    utkColorAdcLightBlue: '#57c1e8',
    utkColorActionDark: '#045489',
    utkColorAction: '#036eb5',
    utkColorActionActiveMedium: '#7bb6dc',
    utkColorActionMedium: '#aee0f2',
    utkColorActionLight: '#d7f3fc',
    utkColorActionExtraLight: '#f0fbfe',
    utkColorInfoDark: '#045489',
    utkColorInfo: '#036eb5',
    utkColorInfoActiveMedium: '#7bb6dc',
    utkColorInfoMedium: '#aee0f2',
    utkColorInfoLight: '#d7f3fc',
    utkColorInfoExtraLight: '#f0fbfe',
    utkColorSuccessDark: '#1d5d02',
    utkColorSuccess: '#297708',
    utkColorSuccessActiveMedium: '#a5cd75',
    utkColorSuccessMedium: '#b8dc8f',
    utkColorSuccessLight: '#d5e8bf',
    utkColorSuccessExtraLight: '#edf3e7',
    utkColorCautionDark: '#cb3c0e',
    utkColorCaution: '#f15c2c',
    utkColorCautionActiveMedium: '#fe9f81',
    utkColorCautionMedium: '#fcc4B3',
    utkColorCautionLight: '#fddacf',
    utkColorCautionExtraLight: '#fef0eb',
    utkColorErrorDark: '#a10000',
    utkColorError: '#c30000',
    utkColorErrorActiveMedium: '#e36c6c',
    utkColorErrorMedium: '#f09c9c',
    utkColorErrorLight: '#f2c5c5',
    utkColorErrorExtraLight: '#fce4e5',
    utkColorPurpleDark: '#541f61',
    utkColorPurple: '#6a277a',
    utkColorPurpleActiveMedium: '#ae78ba',
    utkColorPurpleMedium: '#daa8e5',
    utkColorPurpleLight: '#f2d2f9',
    utkColorPurpleExtraLight: '#fbecfe',
    utkColorBlack: '#000102',
    utkColorNearBlack: '#333',
    utkColorGrayDark: '#263238',
    utkColorGray: '#5c676e',
    utkColorGrayMedium: '#97a0a6',
    utkColorGrayMediumLight: '#c0c8cc',
    utkColorGrayLight: '#dae0e3',
    utkColorGrayExtraLight: '#e9ecee',
    utkColorOffWhiteDark: '#f0f2f4',
    utkColorOffWhite: '#f8f9fa',
    utkColorWhite: '#fff',
    utkColorGraySemantic: '#d3d3d3',
    utkColorAdcLightPurple: '#a639bc',
    utkColorAdcDarkGreen60: 'rgba(41, 119, 8, .6)',
    utkColorAdcLightGreen60: 'rgba(119, 188, 31, .6)',
    utkColorInfo60: 'rgba(3, 110, 181, .6)',
    utkColorBlack60: 'rgba(0, 1, 2, .6)',
    utkColorGrayDark60: 'rgba(38, 50, 56, .6)',
    utkColorDarkCobalt: '#28397f',
    utkColorSunYellow: '#fed000',
    utkColorSalmon: '#eb5353',
    utkColorNavyBlue: '#345771',
    utkColorAquaBlue: '#377a93',
    utkColorCloudBlue: '#f5faff',
    utkColorTransparent: 'transparent',
    utkColorSmartBlueDark: '#2c5cb5',
    utkColorSmartBlue: '#3876e7',
    utkColorSmartBlueActiveMedium: '#6295f3',
    utkColorSmartBlueMedium: '#8bb4ff',
    utkColorSmartBlueLight: '#d4e3ff',
    utkColorSmartBlueExtraLight: '#e5f3ff',
};
export const colorVars = Object.freeze(_colorVars);
export var ColorNames;
(function (ColorNames) {
    ColorNames["AdcDarkGreen"] = "adcDarkGreen";
    ColorNames["AdcLightGreen"] = "adcLightGreen";
    ColorNames["AdcLightBlue"] = "adcLightBlue";
    ColorNames["ActionDark"] = "actionDark";
    ColorNames["Action"] = "action";
    ColorNames["ActionActiveMedium"] = "actionActiveMedium";
    ColorNames["ActionMedium"] = "actionMedium";
    ColorNames["ActionLight"] = "actionLight";
    ColorNames["ActionExtraLight"] = "actionExtraLight";
    ColorNames["InfoDark"] = "infoDark";
    ColorNames["Info"] = "info";
    ColorNames["InfoActiveMedium"] = "infoActiveMedium";
    ColorNames["InfoMedium"] = "infoMedium";
    ColorNames["InfoLight"] = "infoLight";
    ColorNames["InfoExtraLight"] = "infoExtraLight";
    ColorNames["SuccessDark"] = "successDark";
    ColorNames["Success"] = "success";
    ColorNames["SuccessActiveMedium"] = "successActiveMedium";
    ColorNames["SuccessMedium"] = "successMedium";
    ColorNames["SuccessLight"] = "successLight";
    ColorNames["SuccessExtraLight"] = "successExtraLight";
    ColorNames["CautionDark"] = "cautionDark";
    ColorNames["Caution"] = "caution";
    ColorNames["CautionActiveMedium"] = "cautionActiveMedium";
    ColorNames["CautionMedium"] = "cautionMedium";
    ColorNames["CautionLight"] = "cautionLight";
    ColorNames["CautionExtraLight"] = "cautionExtraLight";
    ColorNames["ErrorDark"] = "errorDark";
    ColorNames["Error"] = "error";
    ColorNames["ErrorActiveMedium"] = "errorActiveMedium";
    ColorNames["ErrorMedium"] = "errorMedium";
    ColorNames["ErrorLight"] = "errorLight";
    ColorNames["ErrorExtraLight"] = "errorExtraLight";
    ColorNames["PurpleDark"] = "purpleDark";
    ColorNames["Purple"] = "purple";
    ColorNames["PurpleActiveMedium"] = "purpleActiveMedium";
    ColorNames["PurpleMedium"] = "purpleMedium";
    ColorNames["PurpleLight"] = "purpleLight";
    ColorNames["PurpleExtraLight"] = "purpleExtraLight";
    ColorNames["Black"] = "black";
    ColorNames["NearBlack"] = "nearBlack";
    ColorNames["GrayDark"] = "grayDark";
    ColorNames["Gray"] = "gray";
    ColorNames["GrayMedium"] = "grayMedium";
    ColorNames["GrayMediumLight"] = "grayMediumLight";
    ColorNames["GrayLight"] = "grayLight";
    ColorNames["GrayExtraLight"] = "grayExtraLight";
    ColorNames["OffWhiteDark"] = "offWhiteDark";
    ColorNames["OffWhite"] = "offWhite";
    ColorNames["White"] = "white";
    ColorNames["GraySemantic"] = "graySemantic";
    ColorNames["AdcLightPurple"] = "adcLightPurple";
    ColorNames["AdcDarkGreen60"] = "adcDarkGreen60";
    ColorNames["AdcLightGreen60"] = "adcLightGreen60";
    ColorNames["Info60"] = "info60";
    ColorNames["Black60"] = "black60";
    ColorNames["GrayDark60"] = "grayDark60";
    ColorNames["DarkCobalt"] = "darkCobalt";
    ColorNames["SunYellow"] = "sunYellow";
    ColorNames["Salmon"] = "salmon";
    ColorNames["NavyBlue"] = "navyBlue";
    ColorNames["AquaBlue"] = "aquaBlue";
    ColorNames["CloudBlue"] = "cloudBlue";
    ColorNames["Transparent"] = "transparent";
    ColorNames["SmartBlueDark"] = "smartBlueDark";
    ColorNames["SmartBlue"] = "smartBlue";
    ColorNames["SmartBlueActiveMedium"] = "smartBlueActiveMedium";
    ColorNames["SmartBlueMedium"] = "smartBlueMedium";
    ColorNames["SmartBlueLight"] = "smartBlueLight";
    ColorNames["SmartBlueExtraLight"] = "smartBlueExtraLight";
})(ColorNames || (ColorNames = {}));
export const blendedColorVars = {
    utkColorLightBlueToLightGreen: 'linear-gradient(90deg, #57c1e8 0%, #77bc1f 100%)',
    utkColorOrangeToRed: 'linear-gradient(90deg, #f15c2c 0%, #c30000 100%)',
    utkColorGreenToLightGreen: 'linear-gradient(90deg, #297708 0%, #77bc1f 100%)',
    utkColorPurpleToBlue: 'linear-gradient(90deg, #6a277a 0%, #3876e7 100%)',
};
export var BlendedColorNames;
(function (BlendedColorNames) {
    BlendedColorNames["LightBlueToLightGreen"] = "lightBlueToLightGreen";
    BlendedColorNames["OrangeToRed"] = "orangeToRed";
    BlendedColorNames["GreenToLightGreen"] = "greenToLightGreen";
    BlendedColorNames["PurpleToBlue"] = "purpleToBlue";
})(BlendedColorNames || (BlendedColorNames = {}));
//# sourceMappingURL=colorVars.js.map